import CustomerNotifications from "./Model/CustomerNotifications"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function CustomerNotificationsGet() {
  const params = JSON.stringify({
    PageNumber: 1,
    PageSize: 20,
    ShowOnClinicPortal: true
  })
  return ObservableFromFetch<CustomerNotifications>("FFOrderCustomerNotifications/GetCustomerNotifications", params)
}
